module.exports = __webpack_public_path__ + "static/media/aws.b48cddea.png";